// extracted by mini-css-extract-plugin
export default {"tab-items-parent":"TabSelector_tab-items-parent__Sf5Og","tab-item":"TabSelector_tab-item__eE7zP","active":"TabSelector_active__FUFaR"};